<script setup lang="ts">
import { onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { initPushNotifications } from '@/services/pushNotifications'

const authStore = useAuthStore()

onMounted(async () => {
  await authStore.checkAuth()

  if (authStore.isAuthenticated) {
    initPushNotifications()
  }
})
</script>

<template>
  <router-view />
</template>
